import React from 'react';

export const H1 = ({className = "", children}) => (
    <h1 className={"font-bold text-2xl uppercase "+className}>{children}</h1>
)

export const H2 = ({className = "", children}) => (
    <h2 className={"font-semi-bold text-2xl uppercase  "+className}>{children}</h2>
)